'use client';

import dynamic from 'next/dynamic';

import type { HomeComponentMap } from '../../HomeSectionRenderer';
import CategoryNavBig from '../../components/CategoryNavBig/CategoryNavBig';
import OneLineTwo from '../../components/OneLineTwo/OneLineTwo';
import ProductList from '../../components/ProductList';
import Bestsellers2026 from './components/Bestsellers2026/Bestsellers2026';
import BlogArticle from './components/BlogArticle/BlogArticle';
import BrandImage from './components/BrandImage/BrandImage';
import CategoryNavSmall from './components/CategoryNavSmall/CategoryNavSmall';
import CategoryNavShape2026 from './components/CategoryNavShape2026/CategoryNavShape2026';
import FivePicSwiper from './components/FivePicSwiper/FivePicSwiper';
import HeroBanner2026 from './components/HeroBanner2026/HeroBanner2026';
import MaterialGallery2026 from './components/MaterialGallery2026/MaterialGallery2026';
import MultiSwipe from './components/MultiSwipe/MultiSwipe';
import NewArrivals2026 from './components/NewArrivals2026/NewArrivals2026';
import OneRowFourNav from './components/OneRowFourNav/OneRowFourNav';
import ProductInspirationShowcase2026 from './components/ProductInspirationShowcase2026/ProductInspirationShowcase2026';
import StyleGuideCards2026 from './components/StyleGuideCards2026/StyleGuideCards2026';

const StyleHub = dynamic(() => import('./components/StyleHub/StyleHub'), {
  ssr: true,
  loading: () => <div className="h-[300px] animate-pulse bg-[#f5f5f5]" />,
});

// 2026 PC 首页组件逐项显式注册，避免新版组件缺失时静默回退到旧实现。
export const NEW_2026_PC_COMPONENT_MAP: HomeComponentMap = {
  // Hero 轮播复用 2026-wap HomeBanner 渲染；SPM 编码按楼块数据动态生成，PC 包装仅作映射入口。
  swipeImage2026: HeroBanner2026,
  categoryNavSmall: CategoryNavSmall,
  categoryNavShape: CategoryNavShape2026,
  categoryNavBig: CategoryNavBig,
  styleHub: StyleHub,
  multiSwipe: MultiSwipe,
  oneLineTwo: OneLineTwo,
  multiSwipeSecond: FivePicSwiper,
  blogArticle: BlogArticle,
  brandImage: BrandImage,
  regularList: ProductList,
  regularListNewArrivals: NewArrivals2026,
  regularListBestseller: Bestsellers2026,
  oneRowFourNav: OneRowFourNav,
  styleGuideCards2026: StyleGuideCards2026,
  materialGallery2026: MaterialGallery2026,
  productInspirationShowcase2026: ProductInspirationShowcase2026,
};
